import { supabase } from './client';

export async function getClubSettings(): Promise<Record<string, string>> {
  const { data, error } = await supabase.from('club_settings').select('key, value');
  if (error) throw error;
  const map: Record<string, string> = {};
  for (const row of data ?? []) map[row.key] = row.value ?? '';
  return map;
}

export async function setClubSetting(key: string, value: string | null) {
  const { error } = await supabase
    .from('club_settings')
    .upsert({ key, value, updated_at: new Date().toISOString() }, { onConflict: 'key' });

  if (error) throw error;
}
